import React, { useState, useEffect } from "react";

export function AnnouncementBar({ announcement }) {
  const [dismissed, setDismissed] = useState(true);
  useEffect(() => {
    setDismissed(document.cookie.includes("bc_ann_dismissed=1"));
  }, []);
  if (dismissed || !announcement || !announcement.enabled || !announcement.text) return null;
  const dismiss = () => {
    const d = new Date(); d.setDate(d.getDate() + 30);
    document.cookie = `bc_ann_dismissed=1; expires=${d.toUTCString()}; path=/`;
    setDismissed(true);
  };
  return (
    <div className="bg-brand-050 border-b border-line" data-testid="announcement-bar">
      <div className="container-bc flex h-9 items-center justify-center gap-3 text-center">
        <p className="font-mono text-[13px] text-ink-700 truncate">
          {announcement.text}{" "}
          {announcement.link_href && (
            <a href={announcement.link_href} className="underline underline-offset-2 text-brand-700 hover:text-brand-600" data-testid="announcement-link">{announcement.link_text || "Learn more"}</a>
          )}
        </p>
        <button onClick={dismiss} aria-label="Dismiss announcement" className="text-ink-400 hover:text-ink-600 text-sm">×</button>
      </div>
    </div>
  );
}
